import React, { FC } from "react"

import { Button, Group, Modal, ModalProps, Stack, Text } from "@mantine/core"

import { DeviceDocument, useGroups } from "../../../../contexts/devices-context"
import { useLanguage } from "../../../../contexts/language-context"
import useRemoveFromGroup from "./useRemoveFromGroup"
import { IconX } from "@tabler/icons-react"

type RemoveFromGroupModalProps = ModalProps & { device: DeviceDocument }

const RemoveFromGroupModal: FC<RemoveFromGroupModalProps> = ({ device, ...props }) => {
    const { L } = useLanguage()
    const { map } = useGroups()
    const { onRemove, processing } = useRemoveFromGroup(device, props.onClose)

    return (
        <Modal {...props} title={<Text weight="bold">{L("Remove from group")}</Text>}>
            <Stack>
                <Text>
                    {L(
                        "Are you sure that you want to remove %s from group %s? All group settings of this device will be lost, as the device will have no parent group.",
                        <Text weight="bold" span>
                            {device.name}
                        </Text>,
                        map[device.group].name,
                    )}
                </Text>
                <Group position="right" noWrap>
                    <Button variant="subtle" onClick={props.onClose}>
                        {L("Cancel")}
                    </Button>
                    <Button
                        variant="filled"
                        color="red"
                        leftIcon={<IconX size={18} />}
                        onClick={onRemove}
                        loading={processing}
                    >
                        {L("Remove")}
                    </Button>
                </Group>
            </Stack>
        </Modal>
    )
}

export default RemoveFromGroupModal
